import { ReactNode } from "react";
import { createUseStyles } from "react-jss";
import ContentWrapper from "../ContentWrapper";
import classNames from "classnames";

interface Props {
  header?: string;
  description?: string;
  textAlign?: string;
  children?: ReactNode;
  variant?: string;
  image?: string;
}

const useStyles = createUseStyles({
  root: {
    padding: "100px 0px",
    "& h2": {
      marginTop: "0px",
      marginBottom: "10px",
    },
    "@media (max-width: 1480px)": {
      padding: "50px 20px",
    },
  },
  sectionHeader: {
    margin: "0px",
  },
  sectionContent: {
    marginTop: "50px",
  },
  left: {
    textAlign: "left",
  },
  centered: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  image: {
    width: 175,
    marginBottom: 30,
  },
  centeredImage: {
    display: "flex",
    margin: "0 auto 50px",
  },
});

const SectionBlock = ({
  header,
  description,
  textAlign = "left",
  children,
  variant,
  image,
}: Props) => {
  const classes = useStyles();
  return (
    <div
      className={classes.root}
      style={{ backgroundColor: variant === "white" ? "#fff" : "#F0F1F7" }}
    >
      <ContentWrapper>
        {image && (
          <img
            alt={"section logo"}
            src={image}
            className={classNames(classes.image, {
              [classes.left]: textAlign === "left",
              [classes.centeredImage]: textAlign === "center",
              [classes.right]: textAlign === "right",
            })}
          />
        )}
        {header && (
          <h2
            className={classNames({
              [classes.left]: textAlign === "left",
              [classes.centered]: textAlign === "center",
              [classes.right]: textAlign === "right",
            })}
          >
            {header}
          </h2>
        )}
        <p
          className={classNames({
            [classes.left]: textAlign === "left",
            [classes.centered]: textAlign === "center",
            [classes.right]: textAlign === "right",
          })}
        >
          {description}
        </p>
        <div style={{ marginTop: header || description ? "50px" : "0px" }}>
          {children}
        </div>
      </ContentWrapper>
    </div>
  );
};

export default SectionBlock;
